/**
 * Child-component read helpers.
 *
 * ui-lines owns all state for a line's children (see formReducer.js's
 * ADD/REMOVE/UPDATE_LINE_ITEM_CHILD_FIELD actions and lineItems.js's
 * createChildLineItem). ui-children fills in `childRollupSummary` with the
 * real rollup once it builds the presentational panel — this stub keeps the
 * rail and editor callable in the meantime.
 */

export function childList(lineItem) {
  return Array.isArray(lineItem?.children) ? lineItem.children : [];
}

export function childCount(lineItem) {
  return childList(lineItem).length;
}

export function childDisplayName(child, productTypes = []) {
  const name = String(child?.name || "").trim();
  if (name) return name;
  const type = (productTypes || []).find(
    (candidate) => candidate?.key === child?.product_type_key,
  );
  return type?.display_name || child?.product_type_display_name || "Component";
}

/**
 * Read the backend's child rollup verbatim. In particular, material dollars
 * are never reconstructed from the child rows here: the backend owns the
 * rounding and publishes the parent-safe rollup explicitly.
 */
export function childRollupSummary(result) {
  const children = childList(result);
  if (children.length === 0) return null;

  return {
    count: children.length,
    materialPerUnit: result?.children_material_cost_per_unit,
    hoursPerUnit: result?.children_labor_hours_per_unit,
    hasErrors:
      Boolean(result?.children_have_errors) ||
      children.some((child) => Boolean(child?.child_error)),
    uncardedCount: children.filter(
      (child) => child?.rate_card_resolved?.labor_card_missing === true,
    ).length,
  };
}
